module.exports = {
  BasicText: {
    box_style: "Kutu Stili",
    classname: "Class adı",
    padding: "Alan",
    PluginName: "Zengin Metin",
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    opacity: "Opaklık",
    radius: "Radyan",
    source: "Kaynak",
    font_family: "Yazı Tipi",
    font_size: "Yazı Boyutu",
    text_color: "Yazı Rengi",
    highlight_color: "Vurgu Rengi",
    bold: "Kalın",
    italic: "İtalik",
    underline: "Altı Çizili",
  },
};
